import { useContext, useEffect, useRef } from "react";
import { FlatList } from "react-native";
import Svg, { ClipPath, G, Path, Rect } from "react-native-svg";
import { YStack } from "tamagui";

import { LayoutContext } from "@/components/LayoutProvider";
import { Pressable } from "@/components/Pressable";
import { Text } from "@/components/Typography";
import {
  type HistoryItem,
  useHistoryItems,
} from "@/conversation/useHistoryItems";
import { usePropagatedRouter } from "@/hooks/usePropagatedRouter";

const StethoscopeIcon = ({ color }: { color: string }) => (
  <Svg width={18} height={18} viewBox="0 0 24 24" fill="none">
    <G clipPath="url(#clip0_1607_9365)">
      <Path
        d="M7.49991 16.5001L8.24991 16.5001L7.49991 16.5001ZM1 2.49999V1.74999C0.585786 1.74999 0.25 2.08578 0.25 2.49999H1ZM14 8.5H14.75H14ZM14 2.49999H14.75C14.75 2.08578 14.4142 1.74999 14 1.74999V2.49999ZM3 2.49999L3.75 2.49999V2.49999L3 2.49999ZM3 2H2.25V2L3 2ZM6.7499 15L6.74991 16.5001L8.24991 16.5001L8.2499 15L6.7499 15ZM13.9999 23.75H14.4999V22.25H13.9999V23.75ZM14.4999 23.75C18.2278 23.75 21.2499 20.7279 21.2499 17H19.7499C19.7499 19.8995 17.3994 22.25 14.4999 22.25V23.75ZM6.74991 16.5001C6.74991 20.5042 9.99586 23.75 13.9999 23.75V22.25C10.8243 22.25 8.24991 19.6757 8.24991 16.5001L6.74991 16.5001ZM0.25 2.49999V8.5H1.75V2.49999H0.25ZM14.75 8.5V2.49999H13.25V8.5H14.75ZM1 3.24999H3V1.74999H1V3.24999ZM14 1.74999H12V3.24999H14V1.74999ZM7.4999 15.75C11.5039 15.75 14.75 12.5041 14.75 8.5H13.25C13.25 11.6756 10.6756 14.25 7.4999 14.25V15.75ZM0.25 8.5C0.25 12.504 3.49582 15.75 7.4999 15.75V14.25C4.32428 14.25 1.75 11.6757 1.75 8.5H0.25ZM22.25 14.5C22.25 15.4665 21.4664 16.25 20.4999 16.25V17.75C22.2948 17.75 23.75 16.295 23.75 14.5H22.25ZM20.4999 16.25C19.5334 16.25 18.75 15.4665 18.75 14.5H17.25C17.25 16.2949 18.7049 17.75 20.4999 17.75V16.25ZM18.75 14.5C18.75 13.5335 19.5335 12.75 20.5 12.75V11.25C18.7051 11.25 17.25 12.7051 17.25 14.5H18.75ZM20.5 12.75C21.4665 12.75 22.25 13.5335 22.25 14.5H23.75C23.75 12.7051 22.2949 11.25 20.5 11.25V12.75ZM10.5 1.75H11V0.25H10.5V1.75ZM11.25 2V3H12.75V2H11.25ZM11 3.25H10.5V4.75H11V3.25ZM10.5 3.25C10.0858 3.25 9.75 2.91421 9.75 2.5H8.25C8.25 3.74264 9.25736 4.75 10.5 4.75V3.25ZM11.25 3C11.25 3.13807 11.1381 3.25 11 3.25V4.75C11.9665 4.75 12.75 3.9665 12.75 3H11.25ZM11 1.75C11.1381 1.75 11.25 1.86193 11.25 2H12.75C12.75 1.0335 11.9665 0.25 11 0.25V1.75ZM10.5 0.25C9.25736 0.25 8.25 1.25736 8.25 2.5H9.75C9.75 2.08579 10.0858 1.75 10.5 1.75V0.25ZM4.5 0.25H4V1.75H4.5V0.25ZM2.25 2V3H3.75V2H2.25ZM4 4.75H4.5V3.25H4V4.75ZM4.5 4.75C5.74264 4.75 6.75 3.74264 6.75 2.5H5.25C5.25 2.91421 4.91421 3.25 4.5 3.25V4.75ZM2.25 3C2.25 3.9665 3.0335 4.75 4 4.75V3.25C3.86193 3.25 3.75 3.13807 3.75 3H2.25ZM4 0.25C3.0335 0.25 2.25 1.0335 2.25 2H3.75C3.75 1.86193 3.86193 1.75 4 1.75V0.25ZM4.5 1.75C4.91421 1.75 5.25 2.08579 5.25 2.5H6.75C6.75 1.25736 5.74264 0.25 4.5 0.25V1.75ZM12.75 3V2.49999H11.25V3H12.75ZM12.75 2.49999V2H11.25V2.49999H12.75ZM2.25 2L2.25 2.49999L3.75 2.49999L3.75 2L2.25 2ZM2.25 2.49999L2.25 3L3.75 3L3.75 2.49999L2.25 2.49999Z"
        fill={color}
      />
    </G>
    <ClipPath id="clip0_1607_9365">
      <Rect width={24} height={24} fill="white" />
    </ClipPath>
  </Svg>
);

export default function History() {
  const router = usePropagatedRouter();
  const flatListRef = useRef<FlatList<HistoryItem>>(null);

  const { lg, sidebarState, toggleSidebar } = useContext(LayoutContext);

  const { items, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useHistoryItems();

  const itemCount = items.length;
  const previousCountRef = useRef(itemCount);
  const firstItemIdRef = useRef(items[0]?.id);

  useEffect(() => {
    const currentFirstId = items[0]?.id;
    const hasNewItems = itemCount > previousCountRef.current;
    const firstItemChanged = currentFirstId !== firstItemIdRef.current;

    if (hasNewItems && firstItemChanged) {
      flatListRef.current?.scrollToIndex({ index: 0, animated: true });
    }

    previousCountRef.current = itemCount;
    firstItemIdRef.current = currentFirstId;
  }, [itemCount, items]);

  const handleItemPress = (itemId: string) => {
    router.navigate(`/conversation/${itemId}`);
    if (!lg && sidebarState === "expanded") toggleSidebar();
  };

  const handleEndReached = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const renderItem = ({ item }: { item: HistoryItem }) => (
    <Pressable
      indicatorColor={item.hasUnread ? "$fillPrimary" : undefined}
      title={item.title ?? "New conversation"}
      isSelected={item.isSelected}
      onPress={() => handleItemPress(item.conversationId)}
      Icon={item.hasVisit ? StethoscopeIcon : undefined}
    />
  );

  return (
    <>
      <Text
        size="$sm"
        color="$textSecondary"
        paddingHorizontal="$150"
        marginBottom="$150"
      >
        History
      </Text>

      <FlatList
        ref={flatListRef}
        data={items}
        renderItem={renderItem}
        keyExtractor={(item) => item.id}
        onEndReached={handleEndReached}
        onEndReachedThreshold={0.1}
        contentContainerStyle={{ paddingBottom: 16 }}
        ItemSeparatorComponent={() => <YStack height="$50" />}
        style={{ flex: 1 }}
      />
    </>
  );
}
